export default "/app-page/javascript/public/images/light-f2db52ef8fc98ec3.png"